import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { StatusListBinnacle, VisibilityList } from 'src/assets/data/fixedData';

@Component({
  selector: 'app-binnacle-modal',
  templateUrl: './binnacle-modal.component.html',
  styleUrls: ['./binnacle-modal.component.scss'],
  animations: [
    trigger('expandAnimation', [
      state('void', style({ height: '0', opacity: 0 })),
      state('*', style({ height: '*', opacity: 1 })),
      transition('void <=> *', animate('200ms ease-in-out')),
    ]),
  ],
})
export class BinnacleModalComponent implements OnInit {
  // Estado del select personalizado
  readonly selectedValue: string | null = null;
  selectedLabel: string | null = null;
  isOpenStatus = false;
  isOpenClient = false;
  isOpenVisibility = false;
  isOpenExecutionDate = false;
  // Lista de estados (importada desde archivo de constantes)
  readonly statusList: any[] = StatusListBinnacle;
  readonly visibilityList: any[] = VisibilityList;
  customersList: any[] = [];

  readonly executionDateText =
    'En un rango de fechas la fecha de inicio no puede ser mayor a la fecha de fin y la fecha de fin no puede ser menor a la fecha de inicio.';

  startDate: Date | null = null;
  endDate: Date | null = null;

  constructor(
    public readonly dialogRef: MatDialogRef<BinnacleModalComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: any,
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      `datepicker_icon`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/date-picker-icon.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `datepicker_icon_disabled`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/svg/date-picker-icon_disabled.svg')
    );
  }

  ngOnInit(): void {
    // Inicializar clientes
    if (Array.isArray(this.data)) {
      const specialOptions = [
        { code: 'all', name: 'Seleccionar todo', checked: false },
        { code: 'otros', name: 'Otros', checked: false },
        { code: 'ninguno', name: 'Ninguno', checked: false },
      ];

      this.customersList = [
        ...specialOptions,
        ...this.data.map(c => ({
          ...c,
          name: c.name || c.code,
          checked: false,
        })),
      ];
    }
this.restoreCheckboxesFromLocalStorage();
    // 🔁 Restaurar filtros guardados
    this.restoreSavedFilters();
  }

 close(): void {
  this.restoreCheckboxesFromLocalStorage();
  this.dialogRef.close();
}

/**
 * 🔹 Restaura el estado visual de los checkboxes desde localStorage.
 * Si localStorage está vacío, limpia todos los checks.
 */
private restoreCheckboxesFromLocalStorage(): void {
  const saved = localStorage.getItem('binnacleFilters');
  let storedFilters: any = { status: [], visibility: [], customers: [] };

  if (saved) {
    try {
      storedFilters = JSON.parse(saved);
    } catch {
    }
  }

  // 🔹 Restaurar estado visual según localStorage
  this.statusList.forEach(opt => {
    opt.checked = storedFilters.status?.includes(opt.value) || false;
  });

  this.visibilityList.forEach(opt => {
    opt.checked = storedFilters.visibility?.includes(opt.value) || false;
  });

  this.customersList.forEach(opt => {
    opt.checked = storedFilters.customers?.includes(opt.code || opt.name) || false;
  });
}


  toggleSelect(): void {
    this.isOpenStatus = !this.isOpenStatus;
  }
  toggleSelectClient(): void {
    this.isOpenClient = !this.isOpenClient;
  }
  toggleSelectVisibility(): void {
    this.isOpenVisibility = !this.isOpenVisibility;
  }
  toggleSelectExecutionDate(): void {
    this.isOpenExecutionDate = !this.isOpenExecutionDate;
  }


  onCheckboxChange(option: any, list: any[]): void {
    if (option.code === 'all' || option.value === 'all') {
      const newState = option.checked;
      list.forEach(opt => {
        if (opt.code !== 'all' && opt.value !== 'all') {
          opt.checked = newState;
        }
      });
    } else {
      const allChecked = list
        .filter(opt => opt.code !== 'all' && opt.value !== 'all')
        .every(opt => opt.checked);
      const allOption = list.find(opt => opt.code === 'all' || opt.value === 'all');
      if (allOption) allOption.checked = allChecked;
    }
  }

  readonly filterEndDate = (date: Date | null): boolean => {
    if (!this.startDate || !date) return true;
    return date >= this.startDate;
  };

  readonly filterStartDate = (date: Date | null): boolean => {
    if (!this.endDate || !date) return true;
    return date <= this.endDate;
  };
  onStartDateChange(date: Date | null): void {
    this.startDate = date;
    if (this.endDate && this.startDate && this.endDate < this.startDate) {
      this.endDate = null;
    }
  }

  onEndDateChange(date: Date | null): void {
    this.endDate = date;
    if (this.startDate && this.endDate && this.startDate > this.endDate) {
      this.startDate = null;
    }
  }

  // 🟩 Aplicar filtros y guardarlos en localStorage
 applyFilters(): void {
  const filtersToStore = {
    status: this.statusList
      .filter(opt => opt.checked)
      .map(opt => opt.value),  // aquí incluimos "all"
    visibility: this.visibilityList
      .filter(opt => opt.checked)
      .map(opt => opt.value),
    customers: this.customersList
      .filter(opt => opt.checked)
      .map(opt => opt.code || opt.name),
    startDate: this.startDate,
    endDate: this.endDate,
  };

  localStorage.setItem('binnacleFilters', JSON.stringify(filtersToStore));

  // 🔹 Preparamos lo que realmente se enviará al servicio (sin 'all')
  const filtersForService = {
    status: filtersToStore.status.filter(v => v !== 'all'),
    visibility: filtersToStore.visibility.filter(v => v !== 'all'),
    customers: filtersToStore.customers.filter(v => v !== 'all'),
    startDate: this.startDate,
    endDate: this.endDate,
  };

  this.dialogRef.close(filtersForService);
}



  // 🔁 Restaurar estado de los filtros desde localStorage
  restoreSavedFilters(): void {
    const saved = localStorage.getItem('binnacleFilters');
    if (!saved) return;

    try {
      const filters = JSON.parse(saved);

      this.statusList.forEach(opt => (opt.checked = filters.status?.includes(opt.value)));
      this.visibilityList.forEach(opt => (opt.checked = filters.visibility?.includes(opt.value)));
      this.customersList.forEach(opt =>
        (opt.checked = filters.customers?.includes(opt.code || opt.name))
      );

      this.startDate = filters.startDate ? new Date(filters.startDate) : null;
      this.endDate = filters.endDate ? new Date(filters.endDate) : null;
    } catch (err) {
    }
  }
  hasActiveFilters(): boolean {
    const hasStatus = this.statusList.some(opt => opt.checked && opt.value !== 'all');
    const hasVisibility = this.visibilityList.some(opt => opt.checked && opt.value !== 'all');
    const hasCustomers = this.customersList.some(opt => opt.checked && opt.code !== 'all');
    const hasDate = !!(this.startDate || this.endDate);

    return hasStatus || hasVisibility || hasCustomers || hasDate;
  }
  // 🧹 Limpiar filtros y borrar localStorage
  clearFilters(): void {
    this.statusList.forEach(opt => (opt.checked = false));
    this.visibilityList.forEach(opt => (opt.checked = false));
    this.customersList.forEach(opt => (opt.checked = false));
    this.startDate = null;
    this.endDate = null;
    this.selectedLabel = null;
  }
}